import { useSelector } from 'react-redux';

import config from 'constants/config';
import { FASTSPRING_ERROR_EVENT } from 'data/types/event.types';
import { subscriptionsSelector } from 'data/selectors/subscriptions';
import { PAYERS } from 'constants/payers';
import useFastSpringScript from './useFastSpringScript';

const DEFAULT_SDK_URL = 'https://d1f8f9xcsvx3ha.cloudfront.net/sbl/0.8.5/fastspring-builder.min.js';

function catchFastSpringError(code, stringError) {
  const fastSpringEvent = new CustomEvent(FASTSPRING_ERROR_EVENT, {
    detail: {
      code,
      error: stringError,
    },
  });
  window.dispatchEvent(fastSpringEvent);
}

window.catchFastSpringError = catchFastSpringError;

const getPayerStorefront = (payer) =>
  payer === PAYERS.COMPANY //eslint-disable-line
    ? process.env.NODE_ENV === 'development'
      ? config.storefrontApiB2BTest
      : config.storefrontApiB2B
    : process.env.NODE_ENV === 'development'
      ? config.storefrontApiTest
      : config.storefrontApi;

const useFastSpring = ({ sdkUrl = DEFAULT_SDK_URL }) => {
  const subscription = useSelector(subscriptionsSelector);
  const storefront = getPayerStorefront(subscription.payer);

  // put data-debug: true for enable debug mode
  const [loaded] = useFastSpringScript(sdkUrl, {
    'data-access-key': 'XVM64EEERCQL0YLLRRYXPQ',
    'data-popup-closed': 'onFSPopupClosed',
    'data-storefront': storefront,
    id: 'fsc-api',
    type: 'text/javascript',
    'data-error-callback': 'catchFastSpringError',
    'data-data-callback': 'fastSpringDataCallback',
  });

  const { fastspring } = window;

  // if (onPopupClose) {
  //   window.onFSPopupClosed = onPopupClose;
  // }

  return { loaded, fastspring };
};

export default useFastSpring;
